/* B2B Wholesale Page Background Color Script */
document.addEventListener('DOMContentLoaded', () => {
  // Apply background color to html and body
  document.documentElement.style.setProperty('background-color', '#fef3e2', 'important');
  document.body.style.setProperty('background-color', '#fef3e2', 'important');
  
  // Apply background to main content
  const main = document.querySelector('main#MainContent');
  if (main) {
    main.style.setProperty('background-color', '#fef3e2', 'important');
  }
  
  // Find all sections and apply the background color
  const sectionsToColor = [
    '.shopify-section:not(.header-section)',
    '.shopify-section:not(.header-section) .section',
    '.shopify-section .section[class*="color-scheme-"]',
    '.section-wrapper',
    'section[data-color-scheme]'
  ];
  
  sectionsToColor.forEach(selector => {
    const elements = document.querySelectorAll(selector);
    elements.forEach(element => {
      element.style.setProperty('background-color', '#fef3e2', 'important');
    });
  });
  
  // Hide background divs that might interfere
  const backgroundDivs = document.querySelectorAll('.section-background, .custom-section-background');
  backgroundDivs.forEach(div => {
    div.style.setProperty('display', 'none', 'important');
  });
  
  // Make sure page-width containers are transparent
  const pageWidths = document.querySelectorAll('.page-width');
  pageWidths.forEach(element => {
    element.style.setProperty('background-color', 'transparent', 'important');
  });
  
  // Keep form elements white
  const formElements = document.querySelectorAll('._formFieldset_cit2d_82, form');
  formElements.forEach(element => {
    element.style.removeProperty('background-color');
  });
  
  // Use MutationObserver to catch any dynamically added elements
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) { // Element node
          // Check if it's a section that needs background
          if (node.matches && (
            node.matches('.shopify-section') ||
            node.matches('.section') ||
            node.matches('[class*="color-scheme-"]')
          )) {
            node.style.setProperty('background-color', '#fef3e2', 'important');
          }
          
          // Also check children
          if (node.querySelectorAll) {
            const childSections = node.querySelectorAll('.section, [class*="color-scheme-"]');
            childSections.forEach(child => {
              child.style.setProperty('background-color', '#fef3e2', 'important');
            });
          }
        }
      });
    });
  });
  
  observer.observe(document.body, { childList: true, subtree: true });
  
  console.log('B2B Wholesale background color applied with force');
});